import { InjectionToken } from "@angular/core";
import { IWidgetService } from "./i-widget.service";

export const widgetServiceInjectionToken: InjectionToken<IWidgetService> = new InjectionToken<IWidgetService>("digital-signage.developer-dashboard.WidgetService");
